import React, { useState } from "react";
import $ from "jquery";
import { useStateContext } from "../../context/ContextProvider";
import { useNavigate } from "react-router-dom";
import Loading from "../Loading/Loading";

import {
  BsPinMap,
  BsEnvelopeAt
} from "react-icons/bs";

import {
  PiFacebookLogoDuotone,
  PiLinkedinLogoDuotone,
  PiInstagramLogoDuotone,
  PiTiktokLogoDuotone,
  PiSnapchatLogoDuotone,
  PiMapPin,
  PiEnvelope
} from "react-icons/pi";
import useFadeInOnScroll from "../Effects/FadeInOnScroll";

const Socials = [
  {
    "title": "LinkedIn",
    "icon": <PiLinkedinLogoDuotone size={24} />,
    "link": "https://www.linkedin.com/company/dodealagency",
  },
  {
    "title": "Facebook",
    "icon": <PiFacebookLogoDuotone size={24} />,
    "link": "https://www.facebook.com/profile.php?id=61569889287329",
  },
  {
    "title": "Instagram",
    "icon": <PiInstagramLogoDuotone size={24} />,
    "link": "https://www.instagram.com/dodeal.agency/",
  },
  {
    "title": "TikTok",
    "icon": <PiTiktokLogoDuotone size={24} />,
    "link": "https://www.tiktok.com/@dodeal.agency",
  },
  {
    "title": "Snapchat",
    "icon": <PiSnapchatLogoDuotone size={24} />,
    "link": "https://web.snapchat.com/?ref=homepage_auto_redirect",
  }
];

const Contact = () => {
  useFadeInOnScroll();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    filename: window.location.href,
  });
  const [errors, setErrors] = useState({});
  const { BACKEND_URL, t, userInfo } = useStateContext();
  const [loading, setLoading] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);

  const navigate = useNavigate();
  const validate = () => {
    const newErrors = {};

    // Validate name
    if (!formData.name) {
      newErrors.name = t("validation_name");
    }

    // Validate email
    if (!formData.email) {
      newErrors.email = t("validation_email");
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        newErrors.email = t("validation_email_invalid");
      }
    }

    // Validate message
    if (!formData.message) {
      newErrors.message = t("validation_message");
    }

    return newErrors;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form submitted: ", formData);

    // Validate form
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setErrors(newErrors);
    setLoading(true);

    try {
      // AJAX CALL
      $.ajax({
        url: `${BACKEND_URL}backend/controllers/ContactEnquiryMail.php`,
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify(formData),
        dataType: "json",
        success: function (response) {
          console.log("Response from backend:", response);
          if (response.success) {
            console.log("Form submitted successfully.");
            setFormSubmitted(true);
          } else {
            console.error("Backend returned an error:", response.status);
          }
          setLoading(false);
          // navigate("/thankyou");
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.error("AJAX Error:", textStatus, errorThrown);
          console.log("Response Text:", jqXHR.responseText);
        },
      });
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  return (
    <div id="contact" className="relative z-[100]"
      style={{
        zIndex: 11
      }}
    >
      <div className="my-5 py-5 padding-container w-full">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 text-start">
          {/* TEXT */}
          <div className="col-span-1 py-5 flex flex-col gap-2">
            <div className="fade-element text-2xl md:text-3xl lg:text-3xl font-bold uppercase">
              Connect
            </div>
            <div className="fade-element text-6xl md:text-7xl lg:text-7xl font-bold uppercase mb-4">
              Lets&nbsp;
              <br className="hidden lg:flex" />
              make&nbsp;
              <br />
              a deal
            </div>
            <div className="flex w-full justify-end">
              <div className="fade-element text-sm md:w-3/5 text-slate-500">
                Reach out to our team for inquiries, collaborations, or support.
                Let’s build something amazing together
              </div>
            </div>
          </div>
          {/* FORM */}
          <div className="col-span-1 lg:col-span-2"
            style={{
              background: "linear-gradient(133.7deg, rgba(255, 255, 255, 0.2) -3.49%, rgba(116, 159, 237, 0.2) 128.73%)",
              border: "0.5px solid",
              borderImageSource: "linear-gradient(165.4deg, rgba(0, 0, 0, 0.2) -10.07%, rgba(255, 255, 255, 0) 89.61%)",
              borderRadius: "20px",
              borderWidth: "0.5px",
              mixBlendMode: "Lighten"

            }}>
            <form
              onSubmit={handleSubmit}
              className="w-full h-full p-8 relative"
            >
              {/* <div className="absolute inset-0 bg-white/20 backdrop-blur-lg rounded-2xl -z-4"></div> */}
              <div class="fade-element text-start text-2xl md:text-3xl lg:text-3xl z-1 relative">
                Contact Us
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full z-[500] py-5">
                {formSubmitted ? (
                  // ✅ Thank You Message
                  <div className="fade-element flex flex-col gap-6 w-full h-full items-center justify-center order-1 md:order-0 p-5">
                    <h2 className="text-2xl font-bold text-white">Thank You!</h2>
                    <p className="text-white">Your enquiry has been submitted successfully.</p>
                  </div>
                ) : (
                  <form
                    onSubmit={handleSubmit}
                    className="fade-element flex flex-col gap-6 w-full order-1 md:order-0 p-5">
                    <div>
                      <input
                        value={formData?.name}
                        type="text"
                        style={{
                          borderBottom: "0.5px solid white",
                          borderRadius: "0px !important",
                        }}
                        className="!bg-transparent !text-white border-0 px-2 py-3 !rounded-none focus:outline-none focus:ring-0 !shadow-none relative z-[101] text-lg placeholder:text-base"
                        placeholder="Full Name"
                        onChange={(e) =>
                          setFormData((pre) => ({ ...pre, name: e?.target?.value }))
                        }
                      />
                      {errors.name && (
                        <small className="bg-red-600 text-white">{errors.name}</small>
                      )}
                    </div>
                    <div>
                      <input
                        value={formData?.email}
                        type="text"
                        style={{
                          borderBottom: "0.5px solid white",
                          borderRadius: "0px !important",
                        }}
                        className="!bg-transparent !text-white border-0 px-2 py-3 !rounded-none focus:outline-none focus:ring-0 !shadow-none relative z-[101] text-lg placeholder:text-base"
                        placeholder="Email"
                        onChange={(e) =>
                          setFormData((pre) => ({ ...pre, email: e?.target?.value }))
                        }
                      />
                      {errors.name && (
                        <small className="text-white bg-red-600">{errors.email}</small>
                      )}
                    </div>
                    <div>
                      <input
                        disabled={false}
                        value={formData?.message}
                        type="text"
                        style={{
                          borderBottom: "0.5px solid white",
                          borderRadius: "0px !important",
                        }}
                        className="!bg-transparent !text-white border-0 px-2 py-3 !rounded-none focus:outline-none focus:ring-0 !shadow-none relative z-[101] text-lg placeholder:text-base"
                        placeholder="Message"
                        onChange={(e) =>
                          setFormData((pre) => ({ ...pre, message: e?.target?.value }))
                        }
                      />
                      {errors.name && (
                        <small className="text--red-600">{errors.message}</small>
                      )}
                    </div>
                    <div className="flex justify-center">
                      <button
                        className="fade-element w-fit py-3 px-5 rounded-full cursor-pointer relative z-[5055]"
                        type="button"
                        onClick={handleSubmit}
                        style={{
                          borderRadius: "50px",
                          borderWidth: "0.5px",
                          mixBlendMode: "Lighten",
                          background: "linear-gradient(133.7deg, rgba(255, 255, 255, 0.15) -3.49%, rgba(116, 159, 237, 0.15) 128.73%)",
                          border: "0.5px solid",
                          borderImageSource: "linear-gradient(165.4deg, rgba(0, 0, 0, 0.2) -10.07%, rgba(255, 255, 255, 0) 89.61%)",
                        }}
                      >
                        {loading ? "Submitting..." : "Connect"}
                      </button>
                    </div>
                  </form>
                )}
                <div className="flex flex-col gap-6 w-full order-0 md:order-1 p-5">
                  <div className="fade-element flex flex-col gap-1">
                    <div className="font-bold">
                      Contact
                    </div>
                    <div className="flex flex-wrap gap-2 items-center">
                      <PiEnvelope size={16} />
                      contact@dodeal.com
                    </div>
                  </div>
                  <div className="fade-element flex flex-col gap-1">
                    <div className="font-bold">
                      Based in
                    </div>
                    <div className="flex flex-wrap gap-2 items-center">
                      <PiMapPin size={16} />
                      Dubai, United Arab Emirates
                    </div>
                    <div className="flex flex-wrap gap-2 items-center">
                      <PiMapPin size={16} />
                      Cairo, Egypt
                    </div>
                    <div className="flex flex-wrap gap-2 items-center">
                      <PiMapPin size={16} />
                      Islamabad, Pakistan
                    </div>
                  </div>
                  <div className="fade-element grid grid-cols-5 gap-2">
                    {Socials?.map((social, index) => {
                      return (
                        <a
                          href={social?.link}
                          target="_blank"
                          className="rounded-[20px] aspect-square flex items-center justify-center p-1"
                          style={{
                            background: "linear-gradient(149.54deg, rgba(211, 211, 211, 0.2) 22.72%, rgba(255, 255, 255, 0.5) 115.21%)"
                          }}
                        >
                          {social?.icon}
                        </a>
                      );
                    })}
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Contact;
